/* eslint-disable */
import { removeScripts } from 'common-utils';

import { TrackEvent, TrackingTool } from '../tracking-tool';

declare global {
  interface Window {
    fbq: any;
  }
}
const trackingPixelId = 'facebook-tracking-pixel';

export class FacebookTrackingPixel implements TrackingTool {
  private _id: string;

  constructor(id: string) {
    this._id = id;
  }

  async trackEvent({ label, action, category }: TrackEvent) {
    if (window.fbq) {
      window.fbq('trackCustom', label, { action, category });
    }
  }

  getName(): string {
    return 'facebookTrackingPixel';
  }

  async turnOff() {
    removeScripts(['https://connect.facebook.net/en_US/fbevents.js']);
    document.getElementById(trackingPixelId)?.remove();
  }

  async turnOn() {
    createPixel(this._id);
    // @ts-ignore
    !(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    );
    window.fbq('init', this._id);
    window.fbq('track', 'PageView');
  }
}

function createPixel(facebookId: string) {
  const noscript = document.createElement('noscript');
  const pixel = document.createElement('img');
  pixel.height = 1;
  pixel.width = 1;
  pixel.src = `https://www.facebook.com/tr?id=${facebookId}&ev=PageView&noscript=1`;
  noscript.appendChild(pixel);
  noscript.id = trackingPixelId;

  const heads = document.getElementsByTagName('head');
  const head = heads[0];

  if (head) {
    head.appendChild(noscript);
  }
}
